import { Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import VariableChipView from './VariableChipView'

export interface VariableAttributes {
  key: string
  label: string
  fallback: string | null
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    variable: {
      insertVariable: (attributes: VariableAttributes) => ReturnType
    }
  }
}

export const VariableExtension = Node.create({
  name: 'variable',
  group: 'inline',
  inline: true,
  atom: true,

  addAttributes() {
    return {
      key: { default: null },
      label: { default: null },
      fallback: { default: null },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-variable]',
        getAttrs: (dom) => {
          if (typeof dom === 'string') return false
          return {
            key: dom.getAttribute('data-key'),
            label: dom.getAttribute('data-label'),
            fallback: dom.getAttribute('data-fallback'),
          }
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(
        {
          'data-variable': '',
          'data-key': HTMLAttributes.key,
          'data-label': HTMLAttributes.label,
          'data-fallback': HTMLAttributes.fallback,
        },
        HTMLAttributes
      ),
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(VariableChipView)
  },

  addCommands() {
    return {
      insertVariable:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          })
        },
    }
  },
})
